import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  showNotification as shn,
  fetchStart as fs,
  fetchEnd as fe,
} from "react-admin";

import { startMultipleKiosks } from "../lib/serverCommands";

const handleClick = (
  selectedIds,
  { showNotification, fetchStart, fetchEnd }
) => {
  fetchStart();
  startMultipleKiosks({ selectedIds })
    .then(() => showNotification("notification.startOfSell"))
    .catch(err => {
      showNotification("notification.errorSending"); // TODO: message
      console.error("Error sending multiple start kiosk message", err);
    })
    .finally(fetchEnd);
};

const BulkStartButton = ({ selectedIds, ...props }) => (
  <Button label="Démarrer" onClick={() => handleClick(selectedIds, props)} />
);

const styles = () => ({
  container: {
    display: "flex",
  },
});

export default connect(
  null,
  {
    showNotification: shn,
    fetchStart: fs,
    fetchEnd: fe,
  }
)(withStyles(styles)(BulkStartButton));



// WEBPACK FOOTER //
// ./src/components/bulkStartButton.js